module.exports = __webpack_public_path__ + "img/icon-2-white.b8e0366c.png";